// Tynd fetch-wrapper. Alle requests kører med credentials så session-cookie følger med.
// Throws ApiError ved !ok så caller kan vise en meningsfuld besked.

const BASE = (import.meta.env.VITE_API_BASE_URL as string) || "";

export class ApiError extends Error {
  constructor(public status: number, public body: unknown) {
    super(`API ${status}`);
  }
}

async function request<T>(
  method: string,
  path: string,
  body?: unknown,
): Promise<T> {
  return send<T>(
    method,
    path,
    body ? JSON.stringify(body) : undefined,
    body ? "application/json" : undefined,
  );
}

async function send<T>(
  method: string,
  path: string,
  body?: BodyInit,
  contentType?: string,
): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    method,
    credentials: "include",
    headers: contentType ? { "Content-Type": contentType } : undefined,
    body,
  });
  if (!res.ok) {
    let errBody: unknown = null;
    try {
      errBody = await res.json();
    } catch {
      // ignore
    }
    throw new ApiError(res.status, errBody);
  }
  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}

export const api = {
  get: <T,>(p: string) => request<T>("GET", p),
  post: <T,>(p: string, body?: unknown) => request<T>("POST", p, body),
  patch: <T,>(p: string, body?: unknown) => request<T>("PATCH", p, body),
  delete: <T,>(p: string) => request<T>("DELETE", p),
  // Rå fil i body, fx .xlsx til import.
  upload: <T,>(p: string, file: Blob) =>
    send<T>("POST", p, file, "application/octet-stream"),
  // Billede o.l. hvor filtypen følger med.
  putFile: <T,>(p: string, file: File) =>
    send<T>("PUT", p, file, file.type || "application/octet-stream"),
};

// Fejlbesked fra API'et ({ error: "..." }) eller en generisk.
export function errorMessage(e: unknown, fallback = "Noget gik galt"): string {
  if (e instanceof ApiError && e.body && typeof e.body === "object" && "error" in e.body) {
    return String((e.body as { error: unknown }).error);
  }
  return fallback;
}
